// Room activation helpers (extracted from game.ts for headless update path).

import { G, rooms } from './state';
import { Get, Put } from './mapgen';
import { ActivateEnemies } from './demon';
import { spawnContentEnemiesForRoom } from './spawn';
import { getActiveWorld } from './world';

export function LockDoors(r: number): void {
  for (let y = 0; y < rooms[r].h; y++) {
    for (let x = 0; x < rooms[r].w; x++) {
      const rx = x + rooms[r].x;
      const ry = y + rooms[r].y;
      const rt = Get(rx, ry);
      if (rt >= 13 && rt <= 16) Put(rx, ry, rt - 13 + 21, r);
    }
  }
}

export function ActivateRoom(room: number): void {
  if (rooms[room].checkpoint) G.checkpoints_found++;
  if (rooms[room].room_type === 3) LockDoors(room);
  ActivateEnemies(room);
  spawnContentEnemiesForRoom(getActiveWorld(), room);
}
